import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { local420Api } from "../api/local420Api";
import { Gig_Entity } from "../../entities/gig";
import { Ids } from "../../reducers/rhapsody";

const gigsAdapter = createEntityAdapter<Gig_Entity>();
const initialState = gigsAdapter.getInitialState();

export const gigEndpoints = local420Api.injectEndpoints({
  endpoints: (build) => ({
    getGigs: build.query<EntityState<Gig_Entity>, void>({
      query: () => `gigs`,
      transformResponse: (responseData: Gig_Entity[]) => {
        return gigsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["gigs"],
    }),
    getGig: build.query<Gig_Entity, Ids>({
      query: (arg) => {
        return {
          url: `gigs/${arg.id}`,
          params: {
            sourceID: arg.sourceID,
            sourceRecordID: arg.sourceRecordID,
          },
        };
      },
      providesTags: ["gigs"],
    }),
    createGig: build.mutation<Gig_Entity, Partial<Gig_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `gigs`,
      }),
      invalidatesTags: ["gigs", "projects"],
    }),
    updateGig: build.mutation<void, { id: number; body: Partial<Gig_Entity> }>({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `gigs/${args.id}`,
      }),
      invalidatesTags: ["gigs", "projects"],
    }),
    deleteGig: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `gigs/${id}`,
      }),
      invalidatesTags: ["gigs", "projects"],
    }),
  }),
});

export const {
  useGetGigQuery,
  useGetGigsQuery,
  useCreateGigMutation,
  useDeleteGigMutation,
  useUpdateGigMutation,
} = gigEndpoints;

export default gigEndpoints;
